export default class Theme {
  static get pallet() {
    return {
      primaryLight: '#C1ECFF',
      primaryDark: '#0097DA',
      dangerLight: '#e57373',
    };
  }
}
